import { LogOut } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";

export default function AppTopbar({ subtitle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  const initials = (user?.full_name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join("");

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-xl items-center justify-between gap-3 px-4 py-2">
        {/* Full logo (shield + "SignalAgent" text + deco) — never cropped. */}
        <div className="flex items-center gap-2 min-w-0">
          <Logo size={56} />
          {subtitle ? (
            <span
              className="hidden truncate border-l border-slate-200 pl-2 text-[12px] font-medium text-slate-500 sm:inline"
              data-testid="topbar-subtitle"
            >
              {subtitle}
            </span>
          ) : null}
        </div>
        <div className="flex items-center gap-2">
          <div
            className="flex h-9 w-9 items-center justify-center rounded-full bg-[var(--sa-blue-soft)] text-[12px] font-semibold text-[var(--sa-blue-dark)]"
            data-testid="user-avatar"
            aria-label={user?.full_name || ""}
            title={user?.full_name || subtitle || ""}
          >
            {initials || "?"}
          </div>
          <button
            onClick={onLogout}
            data-testid="logout-button"
            className="flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
          >
            <LogOut size={14} />
            <span className="hidden sm:inline">Déconnexion</span>
          </button>
        </div>
      </div>
    </header>
  );
}
